module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'fields',
        'toggle',
    ],

    model: {
        atom: {
            dataType: 'boolean'
        },
        config: {
            strict: true,
            slimSwitch: false
        }
    },
}
